export default function (Store) {
    // nothing to run
}
